import { useTranslation } from "react-i18next";
import "../../../i18n";
import SectionLabel from "../components/SectionLabel";
import BrowserFrame from "../components/BrowserFrame";

const BULLET_KEYS = ["b1", "b2", "b3", "b4", "b5"];
const SAMPLE_Q_KEYS = ["q1", "q2", "q3"];

function QuizSection() {
  const { t } = useTranslation("marketing");

  return (
    <section className="ul-section" style={{ background: "white" }} id="quiz">
      <div className="ul-feature-split">
        <div className="ul-feature-content">
          <SectionLabel>{t("quiz.label")}</SectionLabel>
          <h2 className="ul-section-title">{t("quiz.titleLine1")}<br />{t("quiz.titleLine2")}</h2>
          <p className="ul-section-sub">
            {t("quiz.sub")}
          </p>
          <ul className="ul-feature-points">
            {BULLET_KEYS.map((b) => (
              <li key={b}>
                <span className="ul-check-icon" aria-hidden="true">✓</span>
                {t(`quiz.bullets.${b}`)}
              </li>
            ))}
          </ul>
        </div>
        <div className="ul-feature-visual">
          <div className="ul-card-shell">
            <BrowserFrame domain="app.markszen.com" path="/quiz/create/chemistry-cl12">
              <div className="ul-card-body">
                <div className="ul-upload-zone">
                  <div className="ul-upload-label">{t("quiz.mock.uploadLabel")}</div>
                  <div className="ul-upload-sub">{t("quiz.mock.uploadSub")}</div>
                </div>
                <div className="ul-config-row">
                  <div className="ul-config-chip"><strong>{t("quiz.mock.board")}</strong>CBSE</div>
                  <div className="ul-config-chip"><strong>{t("quiz.mock.class")}</strong>12</div>
                  <div className="ul-config-chip"><strong>{t("quiz.mock.questions")}</strong>20</div>
                  <div className="ul-config-chip"><strong>{t("quiz.mock.type")}</strong>{t("quiz.mock.typeValue")}</div>
                </div>
                <div className="ul-generate-result">
                  <span className="ul-generate-result-check" aria-hidden="true">✓</span>
                  {t("quiz.mock.generated")}
                </div>
                {SAMPLE_Q_KEYS.map((q, i) => (
                  <div className="ul-q-chip" key={q}>
                    <span className="ul-q-num">{t("quiz.mock.qNum", { num: i + 1 })}</span>
                    {t(`quiz.mock.${q}`)}
                  </div>
                ))}
                <div
                  className="ul-q-chip"
                  style={{ color: "var(--ul-slate-light)", justifyContent: "center", background: "none", borderStyle: "dashed" }}
                >
                  {t("quiz.mock.more")}
                </div>
              </div>
            </BrowserFrame>
          </div>
        </div>
      </div>
    </section>
  );
}

export default QuizSection;
